import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import EmptyHeader from '../Shared/EmptyHeader';
import ProviderNav from './ProviderNav';
import EligibilityVerificationSection from './EligibilityVerificationSection';
import ClaimStatusSection from './ClaimStatusSection';
import ProviderContactSection from './ProviderContactSection';
import FAQSection from './FAQSection';

const ProviderPage = () => {
    const [activeSection, setActiveSection] = useState('eligibility-verification-container');
    const [loading, setLoading] = useState(false);

    //ENV Variables
    const companyName = import.meta.env.VITE_COMPANY_NAME;
    const apiURL = import.meta.env.VITE_API;

    //Set Site Title
    document.title = `${companyName} - Provider Lookup`;

    const handleNavClick = (section) => {
        setActiveSection(section);
        setTimeout(() => {
            const sectionElement = document.getElementById(section);
            if (sectionElement) {
                sectionElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }, 100); // slight delay to ensure DOM is updated
    };

    if (loading) return <div></div>;

    return (
        <div className="PolicyDetailsPage">
            <EmptyHeader/>
            <ProviderNav
                selectedSection={activeSection}
                onNavClick={handleNavClick}
            />

            {activeSection === 'eligibility-verification-container' && <EligibilityVerificationSection />}
            {activeSection === 'claim-status-container' && <ClaimStatusSection />}
            {/*{activeSection === 'provider-contact-container' && <ProviderContactSection />}*/}
            {activeSection === 'faq-container' && <FAQSection /> }
        </div>
    );
};

export default ProviderPage;
